import { Route, Switch, Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import ProtectedRoute from 'library/components/protected-route';
import ROUTES from 'library/constants/routes';
import Dashboard from 'modules/dashboard';
import SignIn from 'modules/sign-in';
import NotFound from 'modules/not-found';
import History from 'modules/history';
import 'react-toastify/dist/ReactToastify.css';
import Overlay from 'library/components/overlay';
import {
  getAppEntitiesScrollDisplayState,
  getAppOverlayDisplayState, getAppPointerEventsDisabledState,
} from './store/shared/selectors';
import { GlobalOverflowStyle, GlobalStyle } from './library/styles';

const RootRouter = () => {
  const isAppOverlayDisplayed = useSelector(getAppOverlayDisplayState);
  const isScrollable = useSelector(getAppEntitiesScrollDisplayState);
  const isClickEventsDisabled = useSelector(getAppPointerEventsDisabledState);

  return (
    <>
      <GlobalStyle isScrollable={isScrollable} />
      <GlobalOverflowStyle isOverlayDisplayed={isAppOverlayDisplayed} isClickable={!isClickEventsDisabled} />
      <CSSTransition
        mountOnEnter
        unmountOnExit
        in={!!isAppOverlayDisplayed}
        appear={!!isAppOverlayDisplayed}
        timeout={250}
        classNames="fade"
      >
        <Overlay isGlobal isClickable={!isClickEventsDisabled} />
      </CSSTransition>
      <Switch>
        <Route exact path={ROUTES.LOGIN} component={SignIn} />
        <Route exact path={ROUTES.HISTORY} component={History} />
        <Route exact path={ROUTES.NOT_FOUND} component={NotFound} />
        <ProtectedRoute path={ROUTES.DASHBOARD} component={Dashboard} />
        <Route path="*">
          <Redirect to={ROUTES.NOT_FOUND} />
        </Route>
      </Switch>
    </>
  );
};

export default RootRouter;
